import {useEffect} from 'react'

import {dispatch, useAppSelector} from 'app/store'
import {Policy, PolicyRoutesEnum} from 'interfaces'
import {history} from 'utils'
import {policiesActions} from './policiesSlice'
import {usePolicyAssignmentQuery} from './usePolicyAssignmentQuery'

export const DELETED_POLICY_RESPONSE_MESSAGE = 'Policy not found'

export interface LeaveDeletedPolicyState {
  policyDeleted?: boolean
}

/**
 * Leaves a deleted policy page.
 * When the assignment read returns 400 with "Policy not found", the hook
 * resets the selected policy and opens the policy list with a location-state
 * flag. All Policies reads that flag and shows the toast after it mounts, so
 * the page being left cannot dismiss it on unmount.
 */
export const useLeaveDeletedPolicy = (): void => {
  const {selectedPolicyName} = useAppSelector(rdxSt => rdxSt.policies)
  const policyNameToCheck =
    selectedPolicyName === Policy.BasePolicy ? '' : selectedPolicyName
  const {error, isError, isFetching} =
    usePolicyAssignmentQuery(policyNameToCheck)

  useEffect(() => {
    if (isFetching || !isError) return
    const message = error instanceof Error ? error.message : String(error)
    if (message !== DELETED_POLICY_RESPONSE_MESSAGE) return

    dispatch(policiesActions.updatePolicyName(Policy.BasePolicy))
    history.replace(PolicyRoutesEnum.BASE, {policyDeleted: true})
  }, [error, isError, isFetching])
}
